<template>
	<div class="">
			<div v-if="challenges !== null && challenges.length > 0">
				<b-button block @click="challengesView()">
					<i class="fas fa-flag-checkered pr-1"></i>
					View Challenges
				</b-button>
				<hr v-if="challenge_exists === 1">
				<b-list-group
					v-for="challenge in challenges"
					:key="challenge.id"
					id="challenges"
					class="b-list-item-group text-left mb-1"
				>
                <b-list-group-item class="b-list-item" v-if="challengeCheckMembership(challenge) === true">
				<b-button variant="link" class="gold" @click="showChallengeMembers(challenge)">
					<i class="fas fa-flag-checkered pr-1"></i> <span class="challenge" v-text="challenge.title"></span>
				</b-button>												
				</b-list-group-item>
				</b-list-group>
			</div>
			<div v-else>
				<small class="text-danger">No challenges have been created yet...</small>
			</div>
	</div>
</template>

<script>
import axios from 'axios';
import 'vue-select/dist/vue-select.css';

export default {
	name: 'ChallengesCard',
	components: {
	},
	props: {},
	data() {
		return {
			delete_icon: '',
			message: '',
			message_class: 'text-danger',
            challenge: null,
			challenges: null,
			challenge_exists: null,
			share_members_selected: null,
			share_members: [],
			updateDisabled: true,
		};
	},
	mounted() {
		this.challengesGet();
	},
	methods: {
		challengesGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			axios({
				url: _this.$store.state.api_url + 'challengesGet',
				params: params,
			})
				.then(function (response) {
					_this.isBusy = false;
					if (response.data.status == 1) {
						_this.challenges = Object.values(response.data.challenges);
					} else {
						_this.challenges = null;
					}
					_this.totalRows = _this.challenges.length;
				})
				.catch(function () {
					console.log('Error: challengesGet.');
				});
		},
        showChallengeMembers(challenge) {
			this.$router.push('/challenges/' + challenge.id);
		},
        challengeJoin(challenge) {
			let _this = this;
            let params = new URLSearchParams();
			params.append('challenge', challenge);
            params.append('id', this.$store.state.profile.id)

            axios({
				url: _this.$store.state.api_url + 'challengeJoin',
				params: params,
			})
            .then(function (response) {
					if (response.data.status == 1) {
						if (response.data.challenge !== null) {
                            if (_this.challenge.status === 0) {
									_this.challenges = _this.challenges.filter(
										(item) => item.id !== _this.challenge.id
									);
								} else {
									_this.challenges.find((obj) => {
										if (obj.challenge_leader_user_id === _this.challenge.id) {
											obj = response.data.challenge;
										}
									});
								}				
						}
						_this.totalRows = _this.challenges.length;

						_this.$router.go()
					}
				})
            .catch(function () {
				console.log('Error: challengesGet.');
			});
		},
		challengesView() {
			this.$router.push('/challenges');
		},
		challengeCheckMembership(challenge) {
			let _this = this;
			for (const key in challenge.challenge_members_selected) {
				if (this.$store.state.profile.id === key) {
					_this.challenge_exists = 1;
					console.log("my challenges: " + _this.my_challenges);
					return true;
				}
			}
			
		},
	},
	computed: {},
	watch: {
		share_members_selected() {
			this.updateDisabled = false;
			this.message = '';
		},
	},
};
</script>

<style scoped>
.b-list-item {
	text-align: center;
	padding:2% 0%;
}
</style>
